<template>
  <div id="app">
    <layout-navigation v-if="visible"/>
    <router-view @hide="hideSidebar" @show="showSidebar" :appUsers="allUsers"/>
  </div>
</template>

<script>
import LayoutNavigation from './components/layout/LayoutNavigation.vue'

export default {
  name: 'App',
  components: {
    LayoutNavigation
  },
  data: () => ({
    visible: false,
    allUsers: []
  }),
  methods: {
    hideSidebar () {
      this.visible = false
    },
    showSidebar () {
      this.visible = true
    },
  }
}
</script>

<style lang="scss">
#app{
  min-height: 100vh !important;
  height: 100vh !important;
  background-color: var(--surface-primary);
}
.Vue-Toastification__toast--default.my-custom-toast-class {
    background-color: var(--surface-brand) !important;
}
</style>
